export const VIEW_H = 720;
export const GRAVITY = 1880;
export const HOLD_GRAVITY = 860;
export const JUMP_V = 700;
export const MIN_JUMP_V = 620;
export const WEAK_JUMP_SCALE = 0.55;
export const COYOTE = 0.16;
export const JUMP_BUFFER = 0.16;
export const BASE_SPEED = 190;
export const SPEED_PER_HOUSE = 7.5;
export const MAX_SPEED = 470;
export const PLAYER_W = 34;
export const PLAYER_H = 52;
export const ENERGY_MAX = 100;
export const ENERGY_START = 72;
export const ENERGY_REFILL = 34;
export const ENERGY_DRAIN = 6.8;
export const STUMBLE_TIME = 0.38;
export const LAND_LOCK = 0.05;
export const FALL_DURATION = 1.35;

export const WARM = ["#ffd27a", "#ffe7a8", "#ffbf5e", "#fff1c4"] as const;
export const MULTI = ["#e23d3d", "#3ec46a", "#f4d35e", "#4aa3ff", "#f07ad4"] as const;

export const HOUSE_PALETTES = [
  { wall: "#6b3a2a", trim: "#2a1812", roof: "#2c2430", brick: true },
  { wall: "#d8c6a3", trim: "#5a4634", roof: "#3d2a28", brick: false },
  { wall: "#2f3d4a", trim: "#1b242c", roof: "#1a1518", brick: false },
  { wall: "#8b4a3a", trim: "#3a221c", roof: "#2a1c1c", brick: true },
  { wall: "#c9b48a", trim: "#4a3a28", roof: "#3a2c24", brick: false },
  { wall: "#4a5a48", trim: "#243028", roof: "#241c1c", brick: false },
  { wall: "#e8dcc8", trim: "#6a5440", roof: "#4a3830", brick: false },
] as const;
